import { render, staticRenderFns } from "./userdietorderdetails.vue?vue&type=template&id=5d0b1b39&scoped=true&"
import script from "./userdietorderdetails.vue?vue&type=script&lang=js&"
export * from "./userdietorderdetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d0b1b39",
  null
  
)

export default component.exports